import type { ArticleSeoData } from './jsonld'

export interface OpenGraphTag {
  property: string
  content: string
}

export function generateOpenGraphTags(article: ArticleSeoData): OpenGraphTag[] {
  const tags: OpenGraphTag[] = [
    { property: 'og:type', content: 'article' },
    { property: 'og:title', content: article.title },
    { property: 'og:description', content: article.summary || '' },
    { property: 'og:image', content: article.cover_image || '' },
    { property: 'og:url', content: `https://sxks.go-gg.com/article/${article.id}` },
    { property: 'og:site_name', content: '升学考试网' },
  ]

  if (article.published_at) {
    tags.push({ property: 'article:published_time', content: article.published_at })
  }

  if (article.category) {
    tags.push({ property: 'article:section', content: article.category })
  }

  if (article.tags && article.tags.length) {
    for (const tag of article.tags) {
      tags.push({ property: 'article:tag', content: tag })
    }
  }

  return tags
}
